jQuery(document).ready(function ($) {
    const update_counter = function ($current) {
        return function (swiper) {
            const slide_number = swiper.realIndex + 1;

            $current.text(String(slide_number).padStart(2, '0'));
        };
    };

    const image_carousels = $('.image-carousel__carousel');

    image_carousels.each(function () {
        const $carousel = $(this);
        const $current = $carousel.find('.image-carousel__carousel--counter .current');

        new Swiper(`#${$carousel.attr('id')}`, {
            slidesPerView: 1,
            slidesPerGroup: 1,

            loop: $carousel.find('.swiper-slide').length > 1,

            grabCursor: true,

            navigation: {
                prevEl: '.image-carousel__carousel--prev',
                nextEl: '.image-carousel__carousel--next'
            },

            on: {
                init: update_counter($current),
                slideChange: update_counter($current)
            }
        });
    });
});
